import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const StudioPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Çerez kontrolü
    const hasSeenPopup = localStorage.getItem('studioPopupSeen');

    if (!hasSeenPopup) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem('studioPopupSeen', 'true');
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      
      {/* Çarpı butonu - formun sağ üst köşesine kesin olarak sabitlendi */}
      <Modal.Header 
        closeButton 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          borderBottom: 'none', 
          zIndex: 1050 
        }} 
      />
      
      {/* Dış çerçevenin boyunu tam olarak küçültülmüş formun sığacağı ölçüye (635px) sabitledik */}
      <Modal.Body className="p-0" style={{ overflow: 'hidden', height: '500px', borderRadius: '8px' }}>
        
        <iframe 
          title="Brevo Subscription Form"
          src="https://5c5ee6ce.sibforms.com/v2/serve/MUIFAAfhnXXNPDhuAOE7-cdDBcA54RdjGvpgdh0KAsVC4ZgHpO5_ZOmB61XVz45AjThZP5wot-oZH9QIw5SpixdeRtLCq1U2ES5EqrnZMkpbYSAKc2k6aE9Nbi8nGmvJWzOFHj2AG0g0-Xz04C10WGLD06f5vhka9CEyGXM7aekQLIPj8FBEU0QXNy1TCOhH69rSFxRdOfFD0GFJ" 
          frameBorder="0" 
          scrolling="no" 
          allowFullScreen 
          style={{ 
            display: 'block', 
            width: '118%', /* Küçüldüğünde ekranın %100'ünü tam kaplaması için asıl boyutu genişletildi */
            height: '650px', /* Formun kesilmeden önceki gerçek boyutu */
            transform: 'scale(0.85)', /* Formu tüm yazıları ve butonuyla birlikte %15 küçültür */
            transformOrigin: 'top left' /* Orantının bozulmaması için küçülme işlemini sol üstten başlatır */
          }}
        ></iframe>

      </Modal.Body>
    </Modal>
  );
};

export default StudioPopup;